export const PRACTICE_TEST = [
    {
        id: 1,
        test_name: 'Assessment Test',
        topic_ids: [9],
        use_practice_test_id: true,
        practice_test_id: 1,
        requires_subscription: false
    },
    {
        id: 2,
        test_name: 'Practice Test 1',
        use_practice_test_id: true,
        practice_test_id: 2,
        requires_subscription: true
    },
    {
        id: 3,
        test_name: 'Practice Test 2',
        use_practice_test_id: true,
        practice_test_id: 3,
        requires_subscription: true
    },
    {
        id: 4,
        test_name: 'Practice Test 3',
        use_practice_test_id: true,
        practice_test_id: 4,
        requires_subscription: true
    },
    {
        id: 5,
        test_name: 'Practice Test 4',
        use_practice_test_id: true,
        practice_test_id: 5,
        requires_subscription: true
    },
    {
        id: 6,
        test_name: 'Final Test',
        use_practice_test_id: true,
        practice_test_id: 6,
        requires_subscription: true
    },
];

export const APP_DOMAIN_LIST = [
    {
        id: 1,
        domain_name: 'Customer Accounts',
        chapters: [1],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'lock',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: false
    }, {
        id: 2,
        domain_name: 'Debt Securities',
        chapters: [2],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'database-lock',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }, {
        id: 3,
        domain_name: 'Economics',
        chapters: [3],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'cloud-lock',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }, {
        id: 4,
        domain_name: 'Equity Securities',
        chapters: [4],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'cloud-tags',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }, {
        id: 5,
        domain_name: 'Investment Companies',
        chapters: [5],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'tools',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }, {
        id: 6,
        domain_name: 'Issuing Securities',
        chapters: [6],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'clipboard-list',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }, {
        id: 7,
        domain_name: 'Retirement Plans & Annuities',
        chapters: [7],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'clipboard-list',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }, {
        id: 8,
        domain_name: 'Trading Securities',
        chapters: [8],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'clipboard-list',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }, {
        id: 9,
        domain_name: 'Recommendations & Ethics',
        chapters: [9],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'clipboard-list',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }, {
        id: 10,
        domain_name: 'Options',
        chapters: [10],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'clipboard-list',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }, {
        id: 11,
        domain_name: 'Rules and Regulations',
        chapters: [11],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'clipboard-list',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }
];

export const QUESTION_VERSION_OF_JSON = 1
